<template>
  <div class="same_goods">
    <div class="title">
      <el-divider>{{title}}</el-divider>
    </div>
    <!-- 同系 -->
    <div class="swiper_box" v-if="title==='同系推荐'">
      <Swiper ref="mySwiper" :options="swiperOption" @transitionStart="onTransitionStart">
        <swiper-slide class="swiper-slide" v-for="(item,index) in seriesLike" :key="index">
          <router-link :to="{path:'/goodsDetails/'+v.serNo+'.html'}" target="_blank" v-for="(v,i) in item" :key="i">
            <div class="img mask">
              <img v-lazy="v.mainPreviewImageFilePath">
            </div>
            <!-- <p class="money">￥{{$cookies.isKey('ACCESS_TOKEN')?v.clientSalePrice:v.salePrice | priceValue}}</p> -->
            <div class="sprice com_link" style="padding:6px 0px 0px;text-align:center;">
              市场参考价：
              <span class="line_th">￥{{ v.salePrice | priceValue }}</span>
            </div>
            <div class="money">
              <p class="cprice" v-if="$cookies.isKey('ACCESS_TOKEN')">￥{{ v.clientSalePrice | priceValue}}</p>
              <p class="cprice cur_pointer" v-else style="font-size:14px;" @click.prevent.stop="updateLogin">登录查看多比价</p>
            </div>
          </router-link>
        </swiper-slide>
      </Swiper>
      <div class="swiper-button-next" v-if="seriesLike.length>1" :class="{'swiper-button-disabled':activeIndex==seriesLike.length-1}" @click="nextSlide">
        <i class="myicon iconfont icon-xiayiye"></i>
      </div>
      <div class="swiper-button-prev" v-if="seriesLike.length>1" :class="{'swiper-button-disabled':activeIndex==0}" @click="prevSlide">
        <i class="myicon iconfont icon-xiayiye-copy"></i>
      </div>
    </div>
    <!-- 相似 -->
    <div class="list" v-else>
      <router-link :to="{path:'/goodsDetails/'+v.serNo+'.html'}" target="_blank" v-for="(v,i) in stylesLike" :key="i">
        <div class="img mask">
          <img v-lazy="v.mainPreviewImageFilePath">
        </div>
        <!-- <p class="money">￥{{$cookies.isKey('ACCESS_TOKEN')?v.clientSalePrice:v.salePrice | priceValue}}</p> -->
        <div class="sprice com_link" style="padding:6px 0px 0px;text-align:center;">
          市场参考价：
          <span class="line_th">￥{{ v.salePrice | priceValue }}</span>
        </div>
        <div class="money">
          <p class="cprice" v-if="$cookies.isKey('ACCESS_TOKEN')">￥{{ v.clientSalePrice | priceValue}}</p>
          <p class="cprice cur_pointer" v-else style="font-size:14px;" @click.prevent.stop="updateLogin">登录查看多比价</p>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  props: {
    title: {
      type: String,
      default: "同系推荐",
    },
    seriesLike: {
      type: Array,
      default: () => [],
    },
    stylesLike: {
      type: Array,
      default: () => [],
    },
  },
  components: { Swiper, SwiperSlide },
  data() {
    return {
      swiperOption: {
        autoplay: false,
        // // loop:true,
      },
      activeIndex: 0,
    };
  },
  methods: {
    prevSlide() {
      this.$refs.mySwiper.$swiper.slidePrev();
    },
    nextSlide() {
      this.$refs.mySwiper.$swiper.slideNext();
    },
    // 监听swiper的激活项变化
    onTransitionStart(val) {
      this.activeIndex = val.activeIndex;
    },
    updateLogin() {
      this.$emit("noLogin");
    },
  },
};
</script>

<style lang="less" scoped>
.same_goods {
  width: 100%;
  padding-top: 6px;
  .title {
    width: 100%;
    height: 6px;
    box-sizing: border-box;
    padding: 0 10px;
    .el-divider--horizontal {
      margin: 0;
    }
    .el-divider__text {
      padding: 0 14px;
      font-size: 12px;
      color: #696969;
    }
  }
  .swiper_box {
    margin-top: 10px;
    width: 100%;
    height: 624px;
    position: relative;
    .swiper-button-prev {
      left: 38px;
    }
    .swiper-button-next {
      right: 38px;
    }
    .swiper-button-next,
    .swiper-button-prev {
      top: 100%;
      margin-top: -22px;
      width: 22px;
      height: 22px;
      background: none;
      .myicon {
        font-size: 22px;
        color: #b3b3b3;
      }
    }
    .swiper-button-disabled {
      pointer-events: auto;
      cursor: not-allowed;
    }
  }
  .list {
    margin-top: 10px;
    width: 100%;
  }
  .img {
    display: block;
  }
  .money {
    color: #d00000;
    line-height: 20px;
    padding-bottom: 10px;
    text-align: center;
  }
  .mask {
    position: relative;
    display: block;
    &::after {
      display: block;
      content: "";
      width: 100%;
      height: 100%;
      background: #000000;
      opacity: 0.2;
      position: absolute;
      top: 0;
      left: 0;
      display: none;
    }
    &:hover {
      &::after {
        display: block;
      }
    }
  }
}
</style>